import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Profile from "@/pages/Profile";
import { AuthProvider } from "@/lib/auth";

function App() {
  useEffect(() => {
    document.title = "Aisha Bourdanne · Free Financial Consultations";
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/book/:topicId" element={<Booking />} />
            <Route path="/book" element={<Booking />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/me" element={<Profile />} />
          </Routes>
          <Toaster
            position="top-center"
            toastOptions={{
              style: {
                background: "#FDF8EC",
                border: "1px solid rgba(224,183,44,0.5)",
                color: "#6B1818",
                fontFamily: "Manrope, sans-serif",
              },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
